var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCancelIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  fill: "none",
  viewBox: "0 0 20 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#176F69",
  fillRule: "evenodd",
  d: "M1.2 10.556c0-4.853 3.947-8.8 8.8-8.8a8.78 8.78 0 0 1 6.489 2.861L2.66 15.407A8.75 8.75 0 0 1 1.2 10.557m2.19 5.805A8.78 8.78 0 0 0 10 19.356c4.853 0 8.8-3.947 8.8-8.8 0-1.856-.578-3.58-1.562-5.001zM10 .556c-5.516 0-10 4.484-10 10s4.484 10 10 10 10-4.485 10-10c0-5.516-4.484-10-10-10",
  clipRule: "evenodd"
})));
export { SvgCancelIcon as ReactComponent };